import { render, staticRenderFns } from "./ComplaintCategory.vue?vue&type=template&id=c7ab337e&"
import script from "./ComplaintCategory.vue?vue&type=script&lang=js&"
export * from "./ComplaintCategory.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports